import * as Yup from 'yup';

// Initial values for Delivery form
export const deliveryInitialValues = {
    place_of_delivery: '',
    type_of_delivery: '',
    delivery_complications: [],
    delivery_complication_other: '',
    who_conducted_delivery: [],
    who_conducted_delivery_other: '',
    date_of_delivery: null,
};

// Initial values for Abortion form
export const abortionInitialValues = {
    date_of_abortion: null,
    abortion_type: '',
};

// Initial values for Maternal Death form
export const maternalDeathInitialValues = {
    date_of_death: null,
};

// Delivery validation schema factory
export const getDeliveryValidationSchema = (minDate, maxDate) => {
    return Yup.object().shape({
        place_of_delivery: Yup.string().required('Place of delivery is required'),

        type_of_delivery: Yup.string().required('Type of delivery is required'),

        date_of_delivery: Yup.date()
            .required('Date of delivery is required')
            .nullable()
            .test('min-date', `Date of delivery must be after ${minDate || 'LMC date + 140 days'}`, function (value) {
                if (!value || !minDate) return true;
                return new Date(value) >= new Date(minDate);
            })
            .test('max-date', `Date of delivery cannot be in the future`, function (value) {
                if (!value || !maxDate) return true;
                return new Date(value) <= new Date(maxDate);
            }),

        who_conducted_delivery: Yup.array().when('place_of_delivery', {
            is: 'Home',
            then: (schema) => schema.min(1, 'Who conducted delivery is required'),
            otherwise: (schema) => schema.notRequired(),
        }),

        who_conducted_delivery_other: Yup.string().when('who_conducted_delivery', {
            is: (value) => value && value.includes('Other'),
            then: (schema) => schema.required('Please specify who conducted delivery'),
            otherwise: (schema) => schema.notRequired(),
        }),

        delivery_complications: Yup.array().when('place_of_delivery', {
            is: 'Institutional',
            then: (schema) => schema.min(1, 'Please select at least one complication or None'),
            otherwise: (schema) => schema.notRequired(),
        }),

        delivery_complication_other: Yup.string().when('delivery_complications', {
            is: (complications) => complications && complications.includes('Other'),
            then: (schema) => schema.required('Please specify other complication'),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
};

// Abortion validation schema factory
export const getAbortionValidationSchema = (minDate, maxDate) => {
    return Yup.object().shape({
        date_of_abortion: Yup.date()
            .required('Date of abortion is required')
            .nullable()
            .test('min-date', `Date of abortion must be after ${minDate || 'LMC date or latest vaccination date'}`, function (value) {
                if (!value || !minDate) return true;
                return new Date(value) >= new Date(minDate);
            })
            .test('max-date', `Date of abortion cannot be in the future`, function (value) {
                if (!value || !maxDate) return true;
                return new Date(value) <= new Date(maxDate);
            }),

        abortion_type: Yup.string().required('Abortion type is required'),
    });
};

// Maternal Death validation schema factory
export const getMaternalDeathValidationSchema = (minDate, maxDate) => {
    return Yup.object().shape({
        date_of_death: Yup.date()
            .required('Date of death is required')
            .nullable()
            .test('min-date', `Date of death must be after ${minDate || 'the minimum allowed date'}`, function (value) {
                if (!value || !minDate) return true;
                return new Date(value) >= new Date(minDate);
            })
            .test('max-date', `Date of death cannot be in the future`, function (value) {
                if (!value || !maxDate) return true;
                return new Date(value) <= new Date(maxDate);
            }),
    });
};

// Legacy exports for backward compatibility (using today as maxDate)
export const deliveryValidationSchema = getDeliveryValidationSchema(null, new Date().toISOString().split('T')[0]);
export const abortionValidationSchema = getAbortionValidationSchema(null, new Date().toISOString().split('T')[0]);
export const maternalDeathValidationSchema = getMaternalDeathValidationSchema(null, new Date().toISOString().split('T')[0]);
